import {
  WSMenuItem,
  WSTable,
  WSTableHeaderAction,
  WSTableItem
} from "@wingspanhq/fe-component-library";
import { InvoiceRow } from "@wingspanhq/wingspan-api-sdk";
import React, { useMemo } from "react";
import { getCommonCurrencyCode } from "../../utils/currency";
import { getColumns } from "./columns";

export type InvoicesTableItem = WSTableItem<InvoiceRow>;

type Props = {
  invoices: InvoiceRow[];
  loading?: boolean;
  onRowClick?: (invoice: InvoiceRow) => void;
  onViewInNewTab?: (invoice: InvoiceRow) => void;
  selection?: WSTableItem<InvoiceRow>[];
  onSelectionChange?: (selection: WSTableItem<InvoiceRow>[]) => void;
  rowMenuActions?: (invoice: InvoiceRow) => WSMenuItem[];
  headerAction?: WSTableHeaderAction;
};

export const TableInvoices: React.FC<Props> = props => {
  const currencyCode = useMemo(
    () => getCommonCurrencyCode(props.invoices),
    [props.invoices]
  );

  const tableData = useMemo<InvoicesTableItem[]>(
    () =>
      props.invoices.map(invoice => ({
        id: invoice.id ?? "",
        data: invoice
      })),
    [props.invoices]
  );

  const columns = useMemo(() => getColumns({ currencyCode }), [currencyCode]);

  return (
    <WSTable<InvoiceRow>
      loading={props.loading}
      showHeader
      columns={columns}
      tableData={tableData}
      selection={props.selection}
      onSelectionChange={props.onSelectionChange}
      headerAction={props.headerAction}
      onRowClick={
        props.onRowClick ? item => props.onRowClick!(item.data) : undefined
      }
      onRowControlClick={
        props.onViewInNewTab
          ? item => props.onViewInNewTab!(item.data)
          : undefined
      }
      onRowMousewheelClick={
        props.onViewInNewTab
          ? item => props.onViewInNewTab!(item.data)
          : undefined
      }
      rowMenuActions={
        props.rowMenuActions
          ? item => props.rowMenuActions!(item.data)
          : undefined
      }
    />
  );
};
